// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__25pHi","productName":"Table_productName__3rB4_"};